import { compose, map, reduce, split, trim } from "ramda";

export interface ICookies {
  [cookieName: string]: string;
}

export function parseCookies(rawCookies: string): ICookies {
  return compose(
    reduce((acc: ICookies, elem: string[]) => {
      if (elem.length !== 2) {
        return acc;
      }
      const [key, val] = elem;
      return { ...acc, [key]: val };
    }, {}),
    map(map(trim)),
    map(split("=")),
    split(";"),
    decodeURIComponent
  )(rawCookies);
}

export function getCookies(): ICookies {
  return parseCookies(document.cookie);
}

export function getCookie(name: string): string | null {
  return getCookies()[name];
}
